var _path, _path2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMission(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 186,
    height: 186,
    viewBox: "0 0 186 186",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_419)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M93 186C144.362 186 186 144.362 186 93C186 41.6375 144.362 0 93 0C41.6375 0 0 41.6375 0 93C0 144.362 41.6375 186 93 186Z",
    fill: "#8DC34B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_419",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 38,
    y: 47,
    width: 107,
    height: 107
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M144.72 47H38V153.7H144.72V47Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_419)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.69 76.41C87.77 71.13 93.39 65.3799 98.91 59.5199C106.6 51.37 116.34 47.8499 127.19 47.1399C132.54 46.7899 137.94 47.18 143.42 47.24C145.11 53.84 144.83 59.6899 144.33 65.4999C143.36 76.6399 139.11 86.25 130.74 93.94C125.3 98.94 120.09 104.2 115.14 109C115.14 113.44 114.99 117.14 115.17 120.81C115.69 127.54 113.07 134.13 108.07 138.66C103.41 143.07 99.02 147.77 94.38 152.21C93.49 153.06 91.76 153.96 90.85 153.63C89.98 153.31 89.28 151.47 89.19 150.24C88.78 144.93 88.76 139.58 88.3 134.28C88.16 132.6 87.48 131.01 86.36 129.74C78.24 121.4 70.02 113.17 61.68 105.04C60.5 103.99 59.01 103.36 57.44 103.22C52.13 102.79 46.79 102.76 41.47 102.37C40.22 102.28 38.14 101.56 38.02 100.85C37.96 99.43 38.48 98.0499 39.47 97.0299C44.2 92.07 49.09 87.27 53.95 82.43C57.87 78.3899 63.32 76.1999 68.94 76.4C73.18 76.4799 77.42 76.41 82.68 76.41M64.61 100.01L90.92 126.35C91.28 126.08 91.62 125.8 91.94 125.49C104.62 112.81 117.45 100.27 129.93 87.3899C139.44 77.5799 140.19 65.1799 139.41 52.5099C139.02 52.3299 138.6 52.19 138.18 52.08C137.21 51.98 136.23 51.8999 135.25 51.8699C121.75 51.3999 109.72 54.5399 100.26 65.1099C94.83 71.1699 88.82 76.72 82.98 82.41C76.84 88.39 70.59 94.27 64.6 100M93.81 144.51C98.4 140.26 103.2 136.44 107.21 131.92C111.35 127.25 110.31 121.34 109.79 115.25L93.22 131.97C93.41 136.08 93.62 140.38 93.81 144.51ZM75.72 81.91C64.76 79.46 54.03 85.17 46.58 97.79H59.34L75.71 81.91",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.24 123.05C70.74 123.94 70.16 124.79 69.51 125.58C64.16 131 58.83 136.44 53.3 141.68C52.49 142.45 50.24 142.81 49.45 142.25C47.78 141.06 48.61 139.42 49.91 138.12C55.31 132.74 60.63 127.3 66.12 122.02C67.12 121.32 68.34 120.99 69.56 121.09C70.08 121.09 70.59 122.25 71.24 123.06",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.01 126.58C46.28 125.07 45.89 123.76 48.09 121.46C50.94 118.49 53.89 115.61 56.8 112.7C58.1 111.41 59.8 110.67 60.91 112.41C61.44 113.24 60.99 115.38 60.22 116.23C56.9 119.89 53.3 123.29 50 126.58",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.74 141.33C68.46 137.79 72.21 134.07 76.17 130.58C76.76 130.06 78.91 130.2 79.23 130.72C79.76 131.57 79.89 133.45 79.31 134.09C76.2 137.55 72.9 140.86 69.48 144.02C67.71 145.66 66.52 145.07 64.74 141.33Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.38 81.5299C114.81 81.6799 110.18 77.2799 110.03 71.7099C110.03 71.5599 110.03 71.4099 110.03 71.2499C109.99 65.6099 114.53 60.9999 120.17 60.9499C125.81 60.8999 130.42 65.4499 130.47 71.0899C130.47 71.1599 130.47 71.2199 130.47 71.2899C130.54 76.8699 126.08 81.4499 120.5 81.5199C120.46 81.5199 120.42 81.5199 120.39 81.5199M125.55 71.2699C125.46 68.3199 123.05 65.9699 120.1 65.9599C117.27 66.1099 115.06 68.4399 115.04 71.2699C115.01 74.1099 117.26 76.4499 120.1 76.5199C123.05 76.5799 125.49 74.2399 125.55 71.2899C125.55 71.2899 125.55 71.2799 125.55 71.2699Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_419"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 186,
    height: 186,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMission);
export default __webpack_public_path__ + "static/media/mission.c5760f0b618058ee1634014b3ac9acdc.svg";
export { ForwardRef as ReactComponent };